import axios from "axios";

export default function EntrylocationInviteSubcontractorService(formData, entrylocationId) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/entry_location/" + entrylocationId + "/invite_subcontractor",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
